import type { AxiosResponse } from 'axios';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';

export const getAll = ()
  : Promise<void | AxiosResponse<string []>> => axiosInstance({
  url: ROUTES.SURFACE_TYPES,
  method: 'GET',
  headers: {
    authorization: true,
  },
});
